import LsqPlayer from '../components/LsqPlayer'
import { pad } from '../../maths'
import config from '../../../config'
import { GtagHandler } from '../../../app'

export default {
    delimiters: config.VUE_DELIMITERS,
    components: {
        LsqPlayer
    },
    data: {
        apiURL: null,
        currentIndex: 0,
        questions: [],
        currentQuestion: false,
        firstAnimation: true,
    },
    created() {

        if(!this.apiURL) {
            return
        }

        const xhr = new XMLHttpRequest()
        xhr.open('GET', this.apiURL)

        xhr.onload = () => {
            this.questions = JSON.parse(xhr.responseText)
            this.setCurrentQuestion()
        }

        xhr.send()
    },
    computed: {
        totalQuestions() {
            return this.questions.length
        },
        progress() {
            return this.totalQuestions > 0 ? `${pad(this.currentIndex + 1)}/${pad(this.totalQuestions)}` : false
        },
    },
    watch: {
        currentIndex(index) {
            this.setCurrentQuestion(index)
        },
    },
    methods: {
        next(e) {
            this.currentQuestion.answer = e.currentTarget.getAttribute('data-value')

            if(this.currentIndex === this.totalQuestions - 1) {
                this.onComplete?.()
            } else {
                this.currentIndex++
            }
        },
        prev() {
            if(this.currentIndex === 0) {
                this.onBack?.()
            } else {
                this.currentIndex--
            }
        },
        start() {
            this.toggleModal(true)
            this.setCurrentQuestion()
        },
        toggleModal(show = true) {
            this.modalIsOpen = show
        },
        onBeforeSetCurrentQuestion() {
            return new Promise(resolve => {
                resolve()
            })
        },
        setCurrentQuestion(index = this.currentIndex) {
            GtagHandler.emit('surveySteps', {
                value: this.currentIndex,
            })

            this.onBeforeSetCurrentQuestion().then(() => {
                this.currentQuestion = this.questions[index]
                this.onSetCurrentQuestion?.(index)
            })
        }
    }
}
